module.exports = __webpack_public_path__ + "img/fatture_fornitori_invoiceweb.131ea94f.png";